import {
  Component,
  input,
  output,
  signal,
  computed,
  inject,
} from '@angular/core';

import { JobDetails } from '../../../details/models/details.model';
import { CompanyInsightApiEventData } from '../../../company insight/models/company-insight.model';
import { ToBanglaNumberPipe } from '../../../../shared/pipes/toBanglaNumber.pipe';
import { hasCompanyInsightData } from '../../utils/company-insight.utils';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { DeviceDetectionService } from '../../../../core/services/device-detection';
import { CompanyInsightIndustryDisplayService } from '../../services/company-insight-industry-display.service';
import { InitialsPipe } from '../../../../shared/pipes/Initials.pipe';
import { NgOptimizedImage } from '@angular/common';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-company-info-card',
  imports: [RouterLink, TranslocoModule, ToBanglaNumberPipe, InitialsPipe, NgOptimizedImage],
  templateUrl: './company-info-card.html',
  styleUrl: './company-info-card.scss'
})
export class CompanyInfoCard {
  readonly jobDetails = input<JobDetails | null>(null);
  readonly companyInsight = input<CompanyInsightApiEventData | null>(null);
  readonly isFollowedLocal = input.required<boolean>();
  readonly isCompanyBusinessExpanded = signal(false);
  readonly tooltipOpen = signal(false);
  readonly deviceDetectionService = inject(DeviceDetectionService)
  readonly industryDisplayService = inject(CompanyInsightIndustryDisplayService);
  environment = environment;

  readonly followClicked = output<void>();

  readonly isMobile = computed(() =>this.deviceDetectionService.isMobile());

  readonly visibleIndustries = computed(() =>
    this.industryDisplayService.getVisibleIndustries(this.companyInsight()?.industryInfos, 1)
  );

  readonly hiddenCount = computed(() =>
    this.industryDisplayService.getHiddenCount(this.companyInsight()?.industryInfos, 2)
  );

  readonly hiddenIndustriesTooltipText = computed(() =>
    this.industryDisplayService.getHiddenIndustriesTooltipText(this.companyInsight()?.industryInfos, 2)
  );

  readonly charLimit = computed(() => this.isMobile() ? 150 : 300);

  readonly hasCompanyInsight = computed(() => hasCompanyInsightData(this.companyInsight()));

  readonly shouldShowSeeMoreButton = computed(
    (): boolean => (this.jobDetails()?.CompanyBusiness?.length ?? 0) > this.charLimit()
  );

  readonly displayComBusiness = computed((): string => {
    const text = this.jobDetails()?.CompanyBusiness ?? '';
    const formatted = text.replace(/\r\n/g, '<br/>');
    return this.shouldShowSeeMoreButton() && !this.isCompanyBusinessExpanded()
      ? `${formatted.substring(0, this.charLimit())}...`
      : formatted;
  });

  readonly CompanyWeb = computed(() => {
    const url = this.jobDetails()?.CompanyWeb?.trim() ?? '';
    return url.startsWith('http://') || url.startsWith('https://')
      ? url
      : `https://${url}`;
  });

  onFollow(): void {
    this.followClicked.emit();
  }

  onToggleBusiness(): void {
    this.isCompanyBusinessExpanded.set(!this.isCompanyBusinessExpanded());
  }

  toggleTooltip(event: MouseEvent): void {
    event.stopPropagation();
    this.tooltipOpen.update(open => !open);
  }

  closeTooltip(): void {
    this.tooltipOpen.set(false);
  }
}